import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M7.622 8.61a1.13 1.13 0 1 0 1.256-1.88 1.13 1.13 0 0 0-1.256 1.88" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M18 21.75H6A3.75 3.75 0 0 1 2.25 18V6A3.75 3.75 0 0 1 6 2.25h12A3.75 3.75 0 0 1 21.75 6v8.112a.75.75 0 0 1 0 .333V18A3.75 3.75 0 0 1 18 21.75M20.25 6v6.45l-3.3-3.3a1.75 1.75 0 0 0-2.47 0l-4.05 4.05-.87-.88a1.76 1.76 0 0 0-2.48 0l-3.33 3.337V6A2.25 2.25 0 0 1 6 3.75h12A2.25 2.25 0 0 1 20.25 6m-4.36 4.21 4.36 4.36V18A2.25 2.25 0 0 1 18 20.25H6A2.25 2.25 0 0 1 3.75 18v-.22l4.39-4.38a.27.27 0 0 1 .36 0l1.44 1.41a.77.77 0 0 0 1.06 0l4.54-4.6a.26.26 0 0 1 .35 0",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }